<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 250px;" class="ml-1">
								<v-text-field label="学员姓名" v-model="query.studentName" dense outlined clearable>
								</v-text-field>
							</div>
							<v-btn @click="getTableDataList" color="primary">查询</v-btn>
						</v-col>
					</v-row>
				</template>
				<template v-slot:item.followStatus="{item}">
					<v-chip small :color="statusColor(item.followStatus)">{{ statusName(item.followStatus) }}
					</v-chip>
				</template>

				<template v-slot:item.action="{item}">
					<v-btn @click.stop="showDetail(item)" color="primary" small class="mr-4">详情</v-btn>
					<v-btn v-if="item.studentStatus==='3'" @click.stop="showAdd(item)" color="error" small>跟进</v-btn>
				</template>

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="1">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

		<!-- 添加dialog -->
		<v-dialog title="添加记录" v-model="add.dialog" max-width="600">
			<v-card>
				<v-card-title>添加跟进记录信息</v-card-title>
				<v-card-text>
					<v-row dense>
						<v-col cols="12">
							<v-select :items="statusItems" v-model="add.row.status" item-text="name" item-value="id"
								label="沟通状态" dense outlined clearable></v-select>
						</v-col>
						<v-col cols="12">
							<v-text-field label="跟进内容" v-model="add.row.content" dense outlined></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="add.dialog=false">取消</v-btn>
					<v-btn @click="submitAdd" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog title="跟进记录" v-model="detail.dialog" max-width="600" >
			<v-card style="overflow-y: auto;height: 400px;">
				<v-card-title>
					<span>跟进记录</span>
					<v-spacer></v-spacer>
					<v-icon @click="detail.dialog=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-timeline align-top dense>
						<v-timeline-item v-for="(follow,index) in detail.followList" :key="index" color="pink" small>
							<!-- <template v-slot:icon>
								<v-avatar>
								  <img :src="imgPrev + follow.creatorAvatar">
								</v-avatar>
							</template> -->
							<v-row class="pt-1">
								<v-col cols="3">
									{{follow.createAt}}
								</v-col>
								<v-col cols="6">
									<strong>{{follow.creatorName}}</strong>
									<div style="font-size:14px">
										{{follow.content}}
									</div>
								</v-col>
								<v-col>
									<v-chip :color="statusColor(follow.status)">{{statusName(follow.status)}}</v-chip>
								</v-col>
							</v-row>
						</v-timeline-item>
					</v-timeline>
				</v-card-text>
			</v-card>
		</v-dialog>

	</v-card>
</template>

<script>
	import global from '../../../config/global'
	import utils from "../../../config/utils"
	export default {
		name: "potential-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '教务中心',
						disabled: true
					},
					{
						text: '意向跟进',
						disabled: true
					},
				],
				shopId:"",
				imgPrev:global.imgPrev,
				data: {
					total: 0,
					headers: [
						{
							text: '学员',
							value: 'studentName',
							sortable: false
						},
						{
							text: '联系人关系',
							value: 'contactorCall',
							sortable: false
						},
						{
							text: '联系人电话',
							value: 'contactorMobile',
							sortable: false
						},
						{
							text: '跟进状态',
							value: 'followStatus',
							sortable: false
						},
						{
							text: '跟进内容',
							value: 'latestContent',
							sortable: false
						},
						{
							text: '跟进时间',
							value: 'latestTime',
							sortable: false
						},
						{
							text: '操作',
							align: 'left',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				statusItems: [{
						id: "2",
						name: "沟通中"
					},
					{
						id: "4",
						name: "已成交"
					},
					{
						id: "5",
						name: "已放弃"
					}
				],
				query: {
					loading: false,
					page: 1,
					size: 20,
					studentName: ""
				},
				add: {
					dialog: false,
					row: {
						studentId: "",
						status: "",
						content: "",
					},
				},
				detail: {
					dialog: false,
					followList: []
				}
			}
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.getTableDataList();
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},

			showAdd(item) {
				this.add.row.studentId = item.studentId;
				this.add.dialog = true;
			},
			showDetail(item) {
				this.detail.followList = item.followList;
				this.detail.dialog = true;
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/edu/potential/follow/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;

				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}

				if (this.query.studentName) {
					url += "&studentName=" + this.query.studentName;
				}

				this.axios.get(url).then(response => {

					console.log(response);

					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			statusName(status) {
				let statusName = "未知";
				if (status === '1') {
					statusName = "创建意向";
				} else if (status === '2') {
					statusName = "沟通中";
				} else if (status === '3') {
					statusName = "考虑中";
				} else if (status === '4') {
					statusName = "已成交";
				} else if (status === '5') {
					statusName = "已放弃";
				}
				return statusName;
			},
			statusColor(status) {
				let color = "";
				if (status === '1') {
					color = "primary";
				} else if (status === '2') {
					color = "warning";
				} else if (status === '3') {
					color = "warning";
				} else if (status === '4') {
					color = "success";
				} else if (status === '5') {
					color = "error";
				}
				return color;
			},
			submitAdd() {

				if (!this.add.row.studentId) {
					this.$noty.error('学员不能为空');
					return
				}
				if (!this.add.row.status) {
					this.$noty.error('跟进状态不能为空');
					return
				}

				if (!this.add.row.content) {
					this.$noty.error('跟进内容不能为空');
					return
				}

				// api
				const that = this;
				let url = `/edu/potential/follow/create`;
				let postData = {
					...this.add.row
				};

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				});
			}
		}
	}
</script>

<style>
</style>
